import { render, staticRenderFns } from "./Myrecords.vue?vue&type=template&id=2a3330e6"
import script from "./Myrecords.vue?vue&type=script&lang=js"
export * from "./Myrecords.vue?vue&type=script&lang=js"
import style0 from "./Myrecords.vue?vue&type=style&index=0&id=2a3330e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports